// Single money/number formatting surface, used by both apps so amounts render
// identically everywhere (parts, settings, costs, reports). Formatting follows
// the organization's currency and the active UI language — never a hard-coded
// symbol or suffix.

/**
 * Format an amount as a currency string in the given locale.
 * Falls back to a "<number> <CODE>" form if the currency code is not recognised.
 */
export function formatCurrency(
  amount: number | null | undefined,
  currency: string | null | undefined,
  locale: string,
): string {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  const code = (currency || 'USD').toUpperCase();
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      // IDR/JPY-style zero-decimal currencies collapse fractions automatically;
      // cap the rest at 2 so we never show long tails.
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    return `${formatNumber(amount, locale)} ${code}`;
  }
}

/** Format a plain number in the given locale (no currency styling). */
export function formatNumber(amount: number | null | undefined, locale: string, maxFractionDigits = 2): string {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  return new Intl.NumberFormat(locale, { maximumFractionDigits: maxFractionDigits }).format(Number(amount));
}
